import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../../components/grid";
import Portal from '../../../../components/portal';
import SelectEditor from '../../../../components/grid/Select';
import AparCategoryView from './category';
import Plus_icon from "../../../../assets/images/plus_icon.png";
import { UKG_BILLING_ITEMS } from '../../../../utils/constants';
import { getBillingServices, getAPARSettings, postAPARSettings, editClientData } from "../../../../store/actions";

class APARSetup extends Component {
    billingServicesList = [];
    UKGBillingItems = [];

    state = {
        loading: false,
        isSelectedRowData: "",
        isShow: false,
        isAddOrderShow: false,
        billingServicesList: [],
        UKGBillingItems: [],
        showPopup: false,
        columnDefs: [],
        rowData: [],
        searchText: '',
    };
    billingServices = [];

    async componentDidMount() {
        await this.props.getBillingServices({});
        await this.props.getAPARSettings();
        const rowData = this.props.APAR_SETUP.map(e => {
            let { ARServiceNames } = e;
            ARServiceNames = ARServiceNames.map(sn => sn._id);
            return { ...e, ARServiceNames };
        }) || [];
        this.billingServicesList = this.props.BillingServicesReducer.filter(service => {
            return rowData.filter(set => {
                return !set.ARServiceNames.includes(service._id);
            });
        }).map(srv => ({ label: srv.serviceName, value: srv._id }));
        this.UKGBillingItems = UKG_BILLING_ITEMS.filter(ukg => {
            return rowData.filter(set => {
                return !set.UKGServiceNames.includes(ukg);
            });
        }).map(ukg => ({ label: ukg, value: ukg }));
        let columnDefs = [
            {
                headerName: "Category",
                field: "ARCategory",
                resizable: true,
                width: 150,
                editable: true,
                cellEditor: "agTextCellEditor",
                flex: 1,
            },
            {
                headerName: "Exelforce Service Name",
                field: "ARServiceNames",
                width: 110,
                flex: 1,
                editable: true,
                cellEditorPopup: true,
                cellEditor: SelectEditor,
                //valueFormatter: (params) => params.value?.serviceName,
                //valueParser: params => params.newValue,
                cellEditorParams: {
                    values: (params) => {
                        // params.api, params.data, etc. are available here
                        const rowIndex = params.node.rowIndex;
                        const allRows = [];
                        params.api.forEachNode(node => allRows.push(node.data));
                        // Exclude values selected in other rows
                        const otherSelected = allRows
                            .filter((_, i) => i !== rowIndex)
                            .flatMap(row => row.ARServiceNames || []);
                        return this.props.BillingServicesReducer
                            .filter(service => !otherSelected.includes(service._id))
                            .map(srv => ({ label: srv.serviceName, value: srv._id }));
                    },
                    isMulti: true,
                    isClearable: true,
                    isSearchable: true,
                },
            },
            {
                headerName: "UKG Service Name",
                field: "UKGServiceNames",
                resizable: true,
                width: 150,
                flex: 1,
                cellEditor: SelectEditor,
                editable: true,
                cellEditorPopup: true,
                //valueFormatter: params => Array.isArray(params.value) ? params.value.join(', ') : [params.value],
                cellEditorParams: {
                    values: (params) => {
                        // params.api, params.data, etc. are available here
                        const rowIndex = params.node.rowIndex;
                        const allRows = [];
                        params.api.forEachNode(node => allRows.push(node.data));
                        // Exclude values selected in other rows
                        const otherSelected = allRows
                            .filter((_, i) => i !== rowIndex)
                            .flatMap(row => row.UKGServiceNames || []);
                        return UKG_BILLING_ITEMS
                            .filter(item => !otherSelected.includes(item))
                            .map(itm => ({ label: itm, value: itm }));
                    },
                    isMulti: true,
                    isClearable: true,
                    isSearchable: true,
                },
            },]

        this.setState({ rowData, columnDefs });
    };

    onGridReady = async (params) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
    };

    searchInput = (e) => {
        this.setState({ searchText: e.target.value });
    };

    getServiceNameValues = (params) => {
        const usedIds = this.state.rowData.flatMap(row => row.ARServiceNames?.map(srv => srv._id) || []);
        return this.props.BillingServicesReducer.filter(service => !usedIds.includes(service._id));
    };

    saveSettings = async () => {
        let payload = this.state.rowData;
        await this.props.postAPARSettings(payload);
    };

    closePopup = () => {
        this.setState({ showPopup: false });
    };

    addCategory = () => {
        this.setState({ showPopup: true, title: "Add Category", });
    };

    saveCategory = (val) => {
        let { rowData } = this.state;
        rowData.push({ ARCategory: val, UKGServiceNames: [] });
        this.setState({ rowData, showPopup: false });
        this.gridApi.setRowData(this.state.rowData);
    };


    render() {
        return (
            <>
                <h2 className="page_title">AP/AR Billing Comparison </h2>

                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="filter-field d-flex">
                            <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
                        </div>
                        <div className="filter-field d-flex add_rate" onClick={this.addCategory}>
                            <img src={Plus_icon} />
                            <p>Add Category</p>
                        </div>
                        <div className="filter-field d-flex">
                            <button className="mla fs12 primary mini" onClick={this.saveSettings}>Save</button>
                        </div>
                    </div>
                    <div className="clients_grid">
                        <Grid
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            onGridReady={this.onGridReady}
                            height='600px'
                        >
                        </Grid>
                    </div>
                </div>
                {this.state.showPopup && (
                    <Portal
                        zIndex="101"
                        height="380px"
                        width="380px"
                        close={this.closePopup}
                        title={this.state.title} >
                        <AparCategoryView
                            categoryName={this.state.categoryName}
                            close={this.closePopup}
                            action={this.props}
                            saveCategory={this.saveCategory}
                        ></AparCategoryView>
                    </Portal>
                )}
            </>
        );
    };
};


const mapStateToProps = ({ BillingServicesReducer, APARComparisonReducer }) => {
    let { APAR_SETUP } = APARComparisonReducer;
    return {
        BillingServicesReducer,
        APAR_SETUP
    };
};
export default connect(mapStateToProps, { getBillingServices, postAPARSettings, getAPARSettings, editClientData })(APARSetup);
